var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.editor)?_c('div',{staticClass:"editor"},[_c('editor-content',{staticClass:"preview-container",attrs:{"editor":_vm.editor}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }